import axios from "axios";

const instance = axios.create({
  baseURL: "https://dstapi.ru",
});

export default instance;
